/**
 * パスワード再設定の申請（FR-112①・D-81⑤・C-15）。**未ログインで開く画面**。
 *
 * ★**結果を出し分けない**＝送信の成否も、そのアドレスが登録済みかどうかも画面に出さない。
 *   出すと、フォームに総当たりでアドレスを流すだけで「その会社の誰が登録済みか」の一覧が
 *   作れてしまう（サーバ側で応答を揃えている意味が消える）。唯一の例外は 429（連打の抑止）。
 */

import { ApiError, auth } from "@kenzai/api-client";
import { AuthCard, Button, Field, FormError } from "@kenzai/ui";
import { useState } from "react";

export function PasswordForgot() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (done) {
    return (
      <AuthCard title="メールをお送りしました" subtitle="建材オーダー 卸コンソール">
        <p data-testid="forgot-done" style={{ lineHeight: 1.8 }}>
          ご入力のメールアドレスが登録されている場合は、パスワード再設定のURLをお送りしました。
          メールに書かれたURLを開いて、新しいパスワードを決めてください。
        </p>
        <p style={{ fontSize: "var(--kz-font-size-sm)", color: "var(--kz-color-ink-muted)", lineHeight: 1.8 }}>
          {/* 「届かない」ときに次に何をすればよいかを必ず書く（ここが無いと問い合わせが増える）。 */}
          しばらく経っても届かない場合は、迷惑メールフォルダをご確認のうえ、社内の管理者に
          「設定URLの再発行」をご依頼ください。
        </p>
        <Button fullWidth onClick={() => (window.location.href = "/")}>
          ログイン画面へ
        </Button>
      </AuthCard>
    );
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await auth.forgotPassword(email);
      setDone(true);
    } catch (err) {
      // 429（連打の抑止）だけがここに来る。文言はサーバのものをそのまま出す。
      setError(err instanceof ApiError ? err.message : "送信できませんでした。");
      setBusy(false);
    }
  }

  return (
    <AuthCard title="パスワードの再設定" subtitle="ご登録のメールアドレスにURLをお送りします">
      <form onSubmit={submit} noValidate data-testid="forgot-form">
        <FormError message={error} />
        <Field
          label="メールアドレス"
          type="email"
          name="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button fullWidth type="submit" busy={busy} data-testid="forgot-submit">
          再設定のURLを送る
        </Button>
      </form>
      <p style={{ marginTop: "var(--kz-space-5)", fontSize: "var(--kz-font-size-sm)" }}>
        <a href="/" style={{ color: "var(--kz-color-primary)" }}>
          ログイン画面に戻る
        </a>
      </p>
    </AuthCard>
  );
}
